import { render, staticRenderFns } from "./JobCard.htm?vue&type=template&id=154589c5&scoped=true&"
import script from "./JobCard.ts?vue&type=script&lang=js&"
export * from "./JobCard.ts?vue&type=script&lang=js&"
import style0 from "./JobCard.scss?vue&type=style&index=0&id=154589c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154589c5",
  null
  
)

export default component.exports